import validate from "/usr/src/app/content/n3-spas-668d9b09-7db4-48ad-abd1-d34bce6fc41e/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-668d9b09-7db4-48ad-abd1-d34bce6fc41e/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}